import React from 'react';
import cx from 'classnames';
import LazyLoad from 'react-lazyload';
import PropTypes from 'prop-types';
import _values from 'lodash/values';
import { trackRecommendation } from '../../../../util/trackingHelper';
import styles from './styles.module.less';

const Tile = ({ module, position, isSale }) => {
  const {
    link_label: linkLabel,
    link_path: linkPath,
    images_by_dimension: imagesByDimension,
  } = module;
  const href = linkPath || '/wedding-registry';
  const imgSrc = _values(imagesByDimension)[0];

  // TODO: We must stop destroying and recreating the component before sending the setHasTrackedProductViewed event
  // const [hasTrackedProductViewed, setHasTrackedProductViewed] = useState(false);
  // const tileRef = useRef();
  // const isOnScreen = useOnScreen(tileRef);
  // if (isOnScreen && !hasTrackedProductViewed) {
  //   setHasTrackedProductViewed(true);
  // }

  function handleClick() {
    trackRecommendation('Clicked', {
      recommendation_key: 'PLP Ad Tile Clicked',
      recommendation_name: `Ad Tile #${position}`,
      recommendation_copy: linkLabel,
      location: 'PLP',
      section: null,
    });
  }

  return (
    <a
      className={styles.adTileLink}
      href={isSale ? href : null} // Workaround until figuring out what to do with evergreen marketing tiles
      target="_blank"
      onClick={handleClick}
      rel="noopener noreferrer"
    >
      <LazyLoad once offset={100}>
        <img
          className={cx(styles.listingImg, styles.adTileImg)}
          src={imgSrc}
          alt="Wedding Registry Ad"
        />
      </LazyLoad>
    </a>
  );
};

Tile.propTypes = {
  module: PropTypes.shape({}),
  position: PropTypes.number,
};

export default Tile;
